import { motion } from 'framer-motion';
import { HiBriefcase, HiLocationMarker, HiCalendar } from 'react-icons/hi';
import { experiences } from '../../config';

const ExperienceTab = () => {
  return (
    <div className="lg:pt-12 pt-8 w-full md:w-12/12 px-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="max-w-5xl mx-auto"
      >
        <div className="mb-8 md:mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-2 md:mb-3 text-gray-900 dark:text-white">Experience</h2>
          <p className="text-sm md:text-base text-gray-600 dark:text-gray-400">
            My professional journey and career milestones
          </p>
        </div>
        
        <div className="space-y-6 md:space-y-6">
          {experiences.map((exp, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative"
            >
              {/* Timeline Line - Hidden on mobile, shown on md+ */}
              {index !== experiences.length - 1 && (
                <div className="hidden md:block absolute left-6 top-16 w-0.5 h-full bg-gray-200 dark:bg-gray-800 -z-10"></div>
              )}
              
              <div className="flex gap-3 md:gap-4">
                {/* Company Logo/Initial */}
                <motion.div 
                  whileHover={{ scale: 1.1 }}
                  className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 bg-gray-900 dark:bg-white rounded-lg flex items-center justify-center text-white dark:text-gray-900 font-bold text-base md:text-lg shadow-md border-2 border-gray-200 dark:border-gray-800"
                >
                  {exp.logo}
                </motion.div>

                {/* Content */}
                <div className="flex-1 pb-4 md:pb-6">
                  <motion.div 
                    whileHover={{ x: 5 }}
                    transition={{ duration: 0.2 }}
                    className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-xl p-4 md:p-5 hover:border-gray-400 dark:hover:border-gray-500 hover:shadow-lg transition-all duration-200"
                  >
                    <h3 className="text-lg md:text-xl font-bold text-gray-900 dark:text-white mb-1 leading-tight">
                      {exp.title}
                    </h3>
                    <p className="text-sm md:text-base font-medium text-gray-700 dark:text-gray-300 mb-3">
                      {exp.company} · {exp.type}
                    </p>
                    
                    {exp.description && (
                      <p className="text-xs md:text-sm text-gray-600 dark:text-gray-400 mb-4 leading-relaxed">
                        {exp.description}
                      </p>
                    )}
                    
                    <div className="flex flex-col md:flex-row md:flex-wrap gap-2 md:gap-3 mb-3 text-xs md:text-sm text-gray-600 dark:text-gray-400">
                      <span className="flex items-center gap-1.5">
                        <HiCalendar className="text-gray-500 dark:text-gray-400 flex-shrink-0" />
                        <span className="truncate">{exp.duration} · {exp.period}</span>
                      </span>
                      <span className="flex items-center gap-1.5">
                        <HiLocationMarker className="text-gray-500 dark:text-gray-400 flex-shrink-0" />
                        <span className="truncate">{exp.location} · {exp.workType}</span>
                      </span>
                    </div>

                    {/* Skills */}
                    <div className="flex items-start gap-2 flex-wrap">
                      <HiBriefcase className="text-gray-500 dark:text-gray-400 mt-1 flex-shrink-0" />
                      <div className="flex items-center gap-2 flex-wrap flex-1">
                        {exp.skills.map((skill, skillIndex) => (
                          <span
                            key={skillIndex}
                            className="px-2 py-1 md:px-2.5 md:py-1 bg-gray-100 dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded text-xs font-medium text-gray-700 dark:text-gray-300"
                          >
                            {skill}
                          </span>
                        ))}
                      </div>
                    </div>
                  </motion.div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5, delay: 0.6 }}
          className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-gray-200 dark:border-gray-800"
        >
          <p className="text-gray-600 dark:text-gray-400 text-xs md:text-sm italic">
            Over 12+ years of experience building scalable applications and leading development teams
          </p>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default ExperienceTab;
